export default __webpack_public_path__ + "media/images/svg/secure-icon-53d07f2ee78ae21513d006f46987851a.svg";